export const DEFAULT_GAME_MODE_ID = 'classic_30';

export const FALLBACK_GAME_MODES = [
  {
    id: 'classic_30',
    version: 1,
    title: 'Classic Run',
    short_title: 'Classic',
    tagline: 'Thirty days. One debt. No excuses.',
    description: 'The original thirty-day Dope Man run. Fast, brutal, and built for repeat play.',
    highlights: ['Original 30-day rules', 'Classic starting balance', 'Classic travel danger'],
    max_days: 30,
    debt_deadline: 30,
    requires_debt_clearance: false,
    end_condition: 'day_limit',
    starter_junk: null,
    travel_risk: { police_multiplier: 1, mugging_multiplier: 1 },
  },
  {
    id: 'long_haul_120',
    version: 3,
    title: 'Long Haul',
    short_title: 'Long Haul',
    tagline: 'A longer road, better information, and meaner roadside company.',
    description: 'The same world as Classic across a 120-day career. Low difficulty starts with $3,000 debt and starter junk; better cash buyers, gentler debt-phase selling, and a visited-market notebook reward smart trading. Clear the original debt by day 30.',
    highlights: ['$3,000 Low starting debt', 'Debt-phase buyer premium and market notebook', '$50-$150 starter junk and higher travel danger'],
    max_days: 120,
    debt_deadline: 30,
    requires_debt_clearance: true,
    end_condition: 'debt_gate_then_day_limit',
    starter_junk: {
      minimum_items: 2,
      maximum_items: 4,
      minimum_fence_value: 50,
      maximum_fence_value: 150,
    },
    travel_risk: { police_multiplier: 1.2, mugging_multiplier: 1.1 },
  },
  {
    id: 'career',
    version: 1,
    title: 'Career Mode',
    short_title: 'Career',
    tagline: 'Dumpster to double-wide. No clock. Just survive.',
    description: 'Start nearly broke, unknown, and stuck around Mt. Gate. Earn transportation, climb the residence ladder, deal with the loan shark, and chase Street Legends for as long as you stay alive.',
    highlights: ['$250 cash, Rep 10, and a Dumpster', 'Earn transportation to unlock the wider map', 'Open-ended residence and leaderboard progression'],
    max_days: 0,
    debt_deadline: 0,
    requires_debt_clearance: false,
    end_condition: 'open_ended',
    starter_junk: null,
    travel_risk: { police_multiplier: 1, mugging_multiplier: 1 },
  },
];

export function normalizeGameModes(payload) {
  const modes = Array.isArray(payload?.modes) && payload.modes.length ? payload.modes : FALLBACK_GAME_MODES;
  return modes.filter((mode) => mode?.id && mode?.title).map((mode) => ({ ...mode }));
}

export function validGameModeId(modes, candidate, fallback = DEFAULT_GAME_MODE_ID) {
  return modes.some((mode) => mode.id === candidate) ? candidate : fallback;
}

export function gameModeForState(state) {
  const snapshot = state?.gameMode;
  return {
    id: snapshot?.id || state?.gameModeId || DEFAULT_GAME_MODE_ID,
    version: Number(snapshot?.version || 1),
    title: snapshot?.title || (state?.gameModeId === 'long_haul_120' ? 'Long Haul' : state?.gameModeId === 'career' ? 'Career Mode' : 'Classic Run'),
    shortTitle: snapshot?.shortTitle || (state?.gameModeId === 'long_haul_120' ? 'Long Haul' : state?.gameModeId === 'career' ? 'Career' : 'Classic'),
    maxDays: snapshot?.endCondition === 'open_ended' || snapshot?.id === 'career' || state?.gameModeId === 'career' ? 0 : Number(snapshot?.maxDays || state?.maxDays || 30),
    debtDeadline: snapshot?.id === 'career' || state?.gameModeId === 'career' ? 0 : Number(snapshot?.debtDeadline || state?.maxDays || 30),
    requiresDebtClearance: Boolean(snapshot?.requiresDebtClearance),
    phase: snapshot?.phase || (state?.gameModeId === 'long_haul_120' ? 'debt' : state?.gameModeId === 'career' ? 'career' : 'classic'),
    debtClearedDay: snapshot?.debtClearedDay ?? null,
  };
}

export function gameOverReasonForState(state) {
  if (Number(state?.health || 0) <= 0) return 'health';
  const mode = gameModeForState(state);
  const day = Number(state?.day || 1);
  if (mode.id === 'career') return '';
  if (mode.id === 'long_haul_120' && day > mode.debtDeadline && mode.debtClearedDay == null) return 'debt_deadline';
  if (mode.maxDays > 0 && day > mode.maxDays) return 'day_limit';
  return '';
}
